import { render } from "./InfrasView.vue?vue&type=template&id=19a3154d"
import script from "./InfrasView.vue?vue&type=script&lang=js"
export * from "./InfrasView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__